import {Section} from 'templates/reports/query';

export const parseResults = (rmr: Section) => {
	const headings: string[] = [];
	const rows: Record<string, number>[] = [];

	// Parse our string results into columns
	rmr.results.forEach(({parse}, i) => {
		const fields = parse.split('#');
		if (fields.length % 2 !== 0) {
			return;
		}

		const row: Record<string, number> = {};
		for (let j = 0; j < fields.length; j +=2) {
			const heading = fields[j].split('_')[0];
			if (i === 0) {
				headings.push(heading);
			}
			row[heading] = Math.round(Number(fields[j + 1]));
		}

		rows.push(row);
	});

	return {
		headings,
		rows,
	};
};
